import React from "react";

class NavBar extends React.Component {
  render() {
    return (
      <nav className="NavBar" aria-label="Main navigation">
        <div className="navbar-component-container">
          <div className="navbar-component-links nav-home animate fade-in-from-bottom">
            <a className="navbar-component-links" href="/#Home">Home</a>
          </div>{" "}
          <div className="navbar-component-links nav-exp animate fade-in-from-bottom">
            <a className="navbar-component-links" href="/#Experience">Experience</a>{" "}
          </div>{" "}
          <div className="navbar-component-links nav-skills animate fade-in-from-bottom">
            <a className="navbar-component-links" href="/#Skills">Skills</a>{" "}
          </div>{" "}
          <div className="navbar-component-links nav-portfolio animate fade-in-from-bottom">
            <a
              className="navbar-component-links"
              href="/Scott-Kutler-Resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View resume as PDF (opens in new tab)"
            >Resume</a>
          </div>
        </div>
      </nav>
    );
  }
}
export default NavBar;
